import { render, staticRenderFns } from "./CreateTaskForBusiness.vue?vue&type=template&id=1b64a036"
import script from "./CreateTaskForBusiness.vue?vue&type=script&lang=js"
export * from "./CreateTaskForBusiness.vue?vue&type=script&lang=js"
import style0 from "./CreateTaskForBusiness.vue?vue&type=style&index=0&id=1b64a036&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports